// CreativeStudio's camera hands its stream to OneAdmin's remote-assist (Eyelid) when that is
// installed. PCake has no remote assist, so these are no-ops with the same names.
export async function primeRemoteAssist() { /* not used in PCake */ }
export function setCameraLive() { /* not used in PCake */ }
